import { ScrollView, View } from 'react-native'

import { EverlastingSlider } from '@/src/features/community/ui/components/EverlastingSlider'
import { JourneySlider } from '@/src/features/community/ui/components/JourneySlider'
import { TEST_ID } from '@/src/general/constants/testId'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { PapaStyle } from '../../components/PapaStyle'
import { PrayerSpaceHeader } from '../PrayerSpaceScreen/components/PrayerSpaceHeader'
import { DiscoverSection } from './DiscoverSection'
import { NewPrayerSpaceModal } from './NewPrayerSpaceModal'

type TPrayerSpaceScreenV2Props = {
  isExistingUser: boolean
  userId: number
}

export const PrayerSpaceScreenV2 = ({ isExistingUser, userId }: TPrayerSpaceScreenV2Props) => {
  return (
    <PapaStyle testID={TEST_ID.PRAYER_SPACE.SCREEN}>
      <ScrollView testID={TEST_ID.PRAYER_SPACE.SCREEN} className="min-w-screen max-w-screen flex-1 pb-10">
        <PrayerSpaceHeader isV2 />
        <View className="max-w-5xl w-full mx-auto pb-10">
          <JourneySlider />
          <EverlastingSlider
            trackingSource={TRACKING_SOURCE.PRAYER_SPACE}
            publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.FEED_READ_MORE}
          />
        </View>
        <DiscoverSection />
      </ScrollView>
      {isExistingUser && <NewPrayerSpaceModal userId={userId} />}
    </PapaStyle>
  )
}
